var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"decorator-divider"},[_c('div',{staticClass:"divider"}),_c('img',{style:(_vm.bg ? _vm.colorBg : ''),attrs:{"src":require("@/assets/icons/logo-icon-gray.svg"),"alt":"logo simple clover"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }